var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrenchScrewdriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-wrench-screwdriver",
    fill: "#000000",
    transform: "rotate(180)matrix(-1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "140"), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#767676"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.811,11.799 L11.663,5.947 C12.825,6.548 14.207,6.436 15.095,5.549 C15.779,4.864 16.01,3.883 15.804,2.936 L14.295,4.442 L12.951,4.704 L11.325,3.095 L11.605,1.71 L13.1,0.235 C12.153,0.028 11.17,0.257 10.487,0.941 C9.598,1.829 9.488,3.211 10.089,4.374 L4.237,10.226 C3.074,9.626 1.692,9.738 0.804,10.624 C0.12,11.31 -0.111,12.29 0.096,13.237 L1.604,11.732 L2.947,11.469 L4.575,13.078 L4.294,14.463 L2.799,15.939 C3.745,16.145 4.728,15.917 5.412,15.232 C6.299,14.344 6.41,12.962 5.811,11.799 L5.811,11.799 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.107,12.334 L12.277,11.736 L9.941,9.4 L9.361,9.98 L11.697,12.314 L12.334,14.186 L15.401,16.019 L15.98,15.44 L14.107,12.334 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.277,5.107 L2.478,0.29 C2.075,-0.114 1.367,-0.064 0.9,0.408 L0.367,0.94 C-0.1,1.412 -0.153,2.119 0.252,2.525 L5.049,7.342 L7.277,5.107 L7.277,5.107 Z",
    className: "si-glyph-fill"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrenchScrewdriver);
export default __webpack_public_path__ + "static/media/wrench-screwdriver.6379a30f206964482444e1f8ded1183b.svg";
export { ForwardRef as ReactComponent };